import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function LatestUpdate() {
  const latestComics = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="py-16 px-4 md:px-6 bg-background-50" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 border border-accent-300 text-accent-700 text-xs font-medium rounded-full mb-3">
            每周更新
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新
            <span className="font-heading italic text-primary-500">更新</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            追踪最新更新的韩国漫画，不错过任何精彩内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}